import Button from "../components/Button";
import { useNavigate, useRouteError } from "react-router-dom";

export default function ErrorPage() {
  const navigate = useNavigate();
  const error = useRouteError();

  const isServerError = error?.status === 500;
  const isNotFound = error?.status === 404;

  return (
    <div className="flex flex-col items-center justify-center h-screen gap-4 p-6 text-center">
      <h2 className="text-[12px] uppercase tracking-widest">
        {isServerError ? "500" : isNotFound ? "404" : "Unknown Error"}
      </h2>
      
      <h1 className="text-[40px] mb-5">
        {isServerError
          ? "Oh no! Something went wrong on our end."
          : isNotFound
          ? "Oops! We couldn’t find that page."
          : "Something’s not right."}
      </h1>

      <p className="text-sportsDarkGrey font-semibold">
        {isServerError
          ? "We’re working on it—please try again in a moment."
          : isNotFound
          ? "It may have been moved or no longer exists. Try checking the URL or go back to the previous page."
          : "Our team have been notified and are looking into it."}
      </p>

      <div className="flex flex-col justify-center mt-4">
        <Button onClick={() => navigate(-1)}>Go Back</Button>
      </div>
    </div>
  );
}